import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { PensionArrangementAction } from "../../../../../../Dashboard/Components/Clients/PortfolioDashboard/Components/ProductOverview/Action/PensionArrangementValuationAction";
import { PensionArrangementType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor" 
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { InvestmentPathOptions, investmentPathOptionsMap, PensionPathwayInvestmentOptionArrayBuySellSwitchMap, PensionPathwayInvestmentOptionBuySellSwitchArray } from "../../../../../../Shared/IST/Resource/Content";
import { PensionPathwayInvestmentOption } from "../../../../../../../Wrap/Constants/Enums/PensionPathwayInvestmentOption";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Typography } from "../../../../../../Shared/Typography/Typography";

interface IInvestmentPathwayAnswerSelectionProps extends IProcessComponentProps {
    onInvestPathwayChange: (v) => void;
    onCurrentPathwayChange?: (text: string | null) => void; 
}

interface IInvestmentPathwayAnswerSelectionState {
    hasDrawdownArrangement : boolean
}

export class InvestmentPathwayAnswerSelection extends ProcessComponent<IInvestmentPathwayAnswerSelectionProps, IInvestmentPathwayAnswerSelectionState> {
    constructor(props: IInvestmentPathwayAnswerSelectionProps) {
        super(props);
        this.state = {
            hasDrawdownArrangement : false
        }
    }
    
    componentDidMount() {
        const {data} = this.props;
        const params = getQueryParameters();
        PensionArrangementAction.GetPensionArrangementDetails(params["subaccounthierarchyid"], false, (v) => {
            this.setDrawdownArrangement(v);
        });
    }

    private static validateInvestmentPathwayOptionIsSpecified(v: number): boolean {
        return v != InvestmentPathOptions.NotSpecified;
    }

    private setDrawdownArrangement(arrangementDetails){
        arrangementDetails.forEach(v => {
            if(v.Type != PensionArrangementType.Accumulation){
                this.setState({hasDrawdownArrangement : true});
            }
        });
    }

    private getPathwayTextById(pathwayId: number | null): string | null {
        const selectedPathway = this.props.data?.Contribution?.InvestmentPathwaysSettingsForSettings.find(
            (setting) => setting.InvestmentPathwayQuestionSettingOptionId === pathwayId
        );
        return selectedPathway?.CurrentPathwayInvestmentText || null;
    }    

    private pathwaySettingsConfig = (SelectedPathwayId) => {
        const pathwayText = this.getPathwayTextById(SelectedPathwayId)
        return [
            {
                title: <strong>Selected Investment Pathway:</strong>,
                data: pathwayText
            }
        ];
    };

    public render(): JSX.Element
    {
        const { data } = this.props;

        const contribution = data?.Contribution || {};
        const answers = contribution.InvestmentPathwayAnswers || {};

        const investmentPathOptionsToChoose = [ InvestmentPathOptions.NotSpecified,
                                                InvestmentPathOptions.NoPlan, 
                                                InvestmentPathOptions.GuaranteeIncome,
                                                InvestmentPathOptions.LongTermIncome,
                                                InvestmentPathOptions.Takeout ];

        return (
            <>
                {this.state.hasDrawdownArrangement && <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"Is the transaction linked to Investment Pathway activity?"}
                    selected={answers.PersonalRecommendation == false}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) =>{
                        this.onInvestPathwayChange({ifLinkToInvestmentPath: v})
                    }}
                    required={"Please select"}
                />}

                {answers.PersonalRecommendation === false &&
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"How does the client wish to proceed with the assets in the pension?"}
                    selected={answers.InvestmentOption}
                    options={PensionPathwayInvestmentOptionBuySellSwitchArray}
                    getText={(o) => PensionPathwayInvestmentOptionArrayBuySellSwitchMap[o]}
                    onChange={(v) =>{
                        this.onInvestPathwayChange({InvestmentOption: v})
                        
                    }}
                    required={"Please select"}
                />}

                {answers.PersonalRecommendation === false && 
                 answers.InvestmentOption === PensionPathwayInvestmentOption.InvestmentPathway && 
                <SelectEditor
                        cssWrapper="rg-inline mb-16"
                        label={"Which of the below best reflects your investment aims:"}
                        selected={answers.SelectedPathwayId}
                        options={investmentPathOptionsToChoose}
                        getText={(o) => investmentPathOptionsMap[o]}
                        onChange={(v) => {
                            this.onInvestPathwayChange({ SelectedPathwayId: v })
                        }}
                        validationRules={[
                            {
                                errorMessage: "Please select the one which best reflects your investment aims",
                                validator: InvestmentPathwayAnswerSelection.validateInvestmentPathwayOptionIsSpecified,
                            },
                        ]}
                    />

                }
                {
                    answers.SelectedPathwayId ? <Typography type="common" config={this.pathwaySettingsConfig(answers.SelectedPathwayId)} />
                        : null
                }
            
            </>
            );
        }

    private onInvestPathwayChange(v) {
        const { data } = this.props;
        // Initialize the structure if it doesn't exist
        if (!data.Contribution) {
            data.Contribution = {};
        }
        
        if (!data.Contribution.InvestmentPathwayAnswers) {
            data.Contribution.InvestmentPathwayAnswers = {};
        }
        
        var investmentPathwayAnswers = data.Contribution.InvestmentPathwayAnswers;

        investmentPathwayAnswers.PersonalRecommendation = v.ifLinkToInvestmentPath != undefined ? !v.ifLinkToInvestmentPath : investmentPathwayAnswers.PersonalRecommendation;
        investmentPathwayAnswers.InvestmentOption = v.InvestmentOption ?? investmentPathwayAnswers.InvestmentOption;
        investmentPathwayAnswers.SelectedPathwayId = v.SelectedPathwayId ?? investmentPathwayAnswers.SelectedPathwayId;

        if (investmentPathwayAnswers.SelectedPathwayId != null) {
            investmentPathwayAnswers.LinkedProduct = data.Contribution.InvestmentPathwaysSettingsForSettings.find(
                (setting) => setting.InvestmentPathwayQuestionSettingOptionId === investmentPathwayAnswers.SelectedPathwayId).SelectedInstrumentId;
        }
        
        if (investmentPathwayAnswers.InvestmentOption != PensionPathwayInvestmentOption.InvestmentPathway) {
            investmentPathwayAnswers.SelectedPathwayId = null;
            investmentPathwayAnswers.LinkedProduct = null;
        }

        if (investmentPathwayAnswers.PersonalRecommendation === true) {
            investmentPathwayAnswers.InvestmentOption = null;
            investmentPathwayAnswers.SelectedPathwayId = null;
            investmentPathwayAnswers.LinkedProduct = null;
        }

        this.props.onInvestPathwayChange({ InvestmentPathwayAnswers: investmentPathwayAnswers });

        const pathwayText = this.getPathwayTextById(v.SelectedPathwayId);
        if (this.props.onCurrentPathwayChange) {
            this.props.onCurrentPathwayChange(pathwayText);
        }
    }
}
